module.exports = __webpack_public_path__ + "static/media/aristoteles_desc2.fe220f30.png";